import React from 'react';
import ErrorSVG from '~/assets/img/error.svg';
import Text from '../Text';
import { twMerge } from 'tailwind-merge';

interface Props {
  type?: 'error' | 'warn';
  message: string | undefined;
  className?: string;
}

const InputFeedback: React.FC<Props> = ({
  type = 'error',
  message,
  className,
}) => {
  if (!message) {
    return null;
  }

  if (type === 'warn') {
    return (
      <div className={twMerge('mt-2 flex flex-row items-center', className)}>
        <Text className="ml-2 text-feedback-warning-text font-[14px] flex-1">
          {message}
        </Text>
      </div>
    );
  }

  return (
    <div className={twMerge('mt-2 flex flex-row items-center', className)}>
      <ErrorSVG />
      <Text className="ml-2 text-feedback-error-main text-[14px]">
        {message}
      </Text>
    </div>
  );
};

export default InputFeedback;
